import type {
  FetchBaseArgs,
  RequestResult,
  ResponseProcessorArgs
} from '../types';

export function baseFetch<PayloadType, ResultType>({
  url,
  handleSuccess,
  init,
  errorMessage,
  handleResponse = handleDefaultResponse
}: FetchBaseArgs<PayloadType, ResultType>) {
  return fetch(url, init).then((response) =>
    handleResponse({ response, handleSuccess, errorMessage })
  );
}

export function handleDefaultResponse<PayloadType, ResultType>({
  response,
  handleSuccess,
  errorMessage
}: ResponseProcessorArgs<PayloadType, ResultType>) {
  return response
    .json()
    .then(({ code, message, payload }: RequestResult<PayloadType>) => {
      if (code === 200 || code === 201 || code === 204) {
        return handleSuccess(payload);
      }

      throw new Error(errorMessage || message);
    });
}
